import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, HasProductContext, ProductContext, withProduct } from "@insite/client-framework/Components/ProductContext";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    id: string;
}

const mapStateToProps = (state: CustomApplicationState) => {
    const isAuthenticated = state.context.session!.isAuthenticated;

    return {
        isAuthenticated,
    };
};

type Props = OwnProps & HasProduct & HasProductContext & ReturnType<typeof mapStateToProps>;

const ADIDealerCertificationHeader: React.FC<Props> = ({ product, isAuthenticated, id }) => {
    const productContext = React.useContext(ProductContext);
    const productInfo = productContext.productInfo;
    const pricing = productInfo?.pricing || product.pricing;

    const showAuthorizationRequired =
        pricing &&
        pricing.additionalResults &&
        pricing.additionalResults.isVisible &&
        pricing.additionalResults.isVisible === "N"
            ? "true"
            : "false";
    const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList?.toLowerCase();

    return (
        <>
            {(isAuthenticated && showAuthorizationRequired === "true" && vendorAuthRequiredList === "true") ||
            (isAuthenticated && showAuthorizationRequired === "true" && vendorAuthRequiredList === "false") ? (
                ""
            ) : (
                <StyledWrapper>
                    <Zone contentId={id} zoneName="NotDealerCertifiedHeader"></Zone>
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProduct(ADIDealerCertificationHeader)),
    definition: {
        group: "Basic",
        displayName: "ADI Dealer Certification Header Widget",
    },
};

export default widgetModule;
